import React from 'react';

export default function ErrorModal({ isOpen, onClose, title, message }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[2700] flex items-center justify-center">
      <div className="bg-[#0D1A27] border border-[#273C61] p-6 rounded-lg w-[400px]">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-semibold text-red-400">{title}</h3>
          <button
            onClick={onClose}
            className="text-white/50 hover:text-red-400 transition-colors"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className="text-white/70 mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
} 